import script from "./Renewals.vue?vue&type=script&setup=true&lang=js"
export * from "./Renewals.vue?vue&type=script&setup=true&lang=js"

import "./Renewals.vue?vue&type=style&index=0&id=2c7bd52c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7bd52c"]])

export default __exports__